import { render } from "./TheCanvas.vue?vue&type=template&id=1f6dba78"
import script from "./TheCanvas.vue?vue&type=script&lang=js"
export * from "./TheCanvas.vue?vue&type=script&lang=js"

import exportComponent from "d:\\buildagent\\agent-cidev01-a\\205\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__